<template>   
  <v-autocomplete
    label="Concelhos"
    item-text="name"
    item-value="id"
    multiple
    v-model="cities"
    :items="list_cities"
    :loading="loading"
    v-bind="$props"
  >
      <template v-slot:prepend-item>
        <v-list-item @click="toggleSelection">
            <v-list-item-action>
              <v-checkbox
                :input-value="select_all"
              >
              </v-checkbox>
            </v-list-item-action>
            <v-list-item-content>
            <v-list-item-title>Selecionar todos</v-list-item-title>
            </v-list-item-content>
        </v-list-item>
        <v-divider class="mt-2"></v-divider>
      </template>
      <template v-slot:selection="{ item, index }">
        <v-chip v-if="index <= 5">
          <span>{{ item.name }}</span>
        </v-chip>
        <span
          v-if="index === 5"
          class="grey--text caption"
        >(+{{ cities.length - 5 }} outros)</span>
      </template>
  </v-autocomplete>
</template>

<script>
import { getCities } from "../../services/locals";

export default {
  name: "select-cities-country-area",
  props: {
    country_area: Object,
    name: String,
    autofocus: Boolean
  },
  model: {
    prop: "country_area",
    event: "change"
  },
  data: () => ({
    cities: [],
    list_cities: [],
    loading: false
  }),
  methods: {    
    toggleSelection() {
      if (this.cities?.length == this.list_cities.length)
        this.cities = [];
      else
        this.cities = this.list_cities.map(city => city.id);
    },
    async fetchCities(country_area) {
      this.loading = true;

      if (!country_area.list_cities || country_area.list_cities.length == 0)
        this.list_cities = await getCities(country_area.id);
      else
        this.list_cities = this.country_area.list_cities;

      this.loading = false;
    }
  },
  computed: {
    select_all: function() {
      return this.cities ? this.cities.length == this.list_cities?.length : false;
    }
  },
  created() {
    if (this.country_area) {
      this.cities = this.country_area.cities ? this.country_area.cities : [];
      this.fetchCities(this.country_area);
    } else {
      this.cities = [];
      this.list_cities = [];
    }
  },
  watch: {
    cities: function(value) {
      this.$emit("change", value ? value : []);
    }
  }
};
</script>